import * as action_types from '../actions/action_types';

const initialState = {
  primaryNode: '',
  secondaryNode: '',
  sldName: '',
  id: '',
  height: '',
};

export const MonitoringAppReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case action_types.SYNC_NODE_WITH_DDL:
      return {
        ...state,
        id: action.data.id ? action.data.id : state.id,
        sldName: action.data.sldName,
        primaryNode: action.data.primaryNode,
        secondaryNode: action.data.secondaryNode,
      };
    case action_types.SYNC_SLD_OBJ:
      return {
        ...state,
        sldName: action.data.sldName,
        id: action.data.id,
        secondaryNode: action.data.secondaryNode,
        height: action.data.height,
      };
    default:
      return state;
  }
};
